// Source: app/scripts/controllers/eauction-home-controller.js
/**
 * Created by ristes on 20.4.15.
 */



Auction.controller('EAuctionHomeController', [
  '$scope',
  'crudService',
  'toaster',
  '$filter',
  function ($scope, crudService,toaster,$filter) {

    var service = crudService('auction', {
      getLotsInUpcomingAndRunningAuctions: {
        method: 'GET',
        url: '/data/rest/lots/get_lots_in_upcoming_and_running_auctions/:auctionType',
        isArray: true
      }
    });


    $scope.pageNumber = 1;
    $scope.noAuctionText = 1;

    $scope.allAuction = 1;

    function getProducts(auctionType) {
      $scope.lotsWithProducts = service.getLotsInUpcomingAndRunningAuctions({
        auctionType: auctionType
      }, function (data) {
        if ((data === null || data.length === 0) && $scope.myAuction === 1) {
          // getProducts(3);
          $scope.pageNumber = 1;
          $scope.noAuctionText = 2;
          return;
        }else if ((data === null || data.length === 0) && $scope.runningAuction === 1) {
          // getProducts(2);
          $scope.pageNumber = 1;
          $scope.noAuctionText = 2;
          return;
        }else if ((data === null || data.length === 0) && $scope.upcomingAuction === 1) {
          // getProducts(1);
          $scope.pageNumber = 1;
          $scope.noAuctionText = 2;
          return;
        }else if ((data === null || data.length === 0) && $scope.allAuction === 1) {

          $scope.pageNumber = 2;
        }else{
          $scope.noAuctionText = 1;
        }
      });

    }


    getProducts(1);

    $scope.auctionFilter = function (data) {
      if (data === 1) {
        $scope.allAuction = 1;
        $scope.upcomingAuction = 0;
        $scope.runningAuction = 0;
        $scope.myAuction = 0;
      } else if (data === 2) {
        $scope.allAuction = 0;
        $scope.myAuction = 0;
        $scope.upcomingAuction = 1;
        $scope.runningAuction = 0;
        $scope.myAuction = 0;
      } else if (data === 3) {
        $scope.allAuction = 0;
        $scope.upcomingAuction = 0;
        $scope.runningAuction = 1;
        $scope.myAuction = 0;
      } else {
        $scope.allAuction = 0;
        $scope.upcomingAuction = 0;
        $scope.runningAuction = 0;
        $scope.myAuction = 1;
      }
      getProducts(data);
    };


  }]);



